import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('demo', {
        template: require('./demo-class.html'),
        controller: DemoClassCtrl,
        controllerAs: 'vm'
    });

    DemoClassCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function DemoClassCtrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {
        var vm = this;
        setTimeout(() => {
            $state.go('/', {});
            window.location='';
        }, 100);

        vm.isPassword = false;
        vm.logo = require('Images/nav-logo.png');
        vm.mainBackground = require('Images/bunny.png');
        // The header text on top most of the page
        vm.header = 'Login';
        vm.page = -1;
        vm.version = UTILS.version;
        
        vm.area_codes = require('Images/area_codes.json');
        vm.area_code = `${vm.area_codes[0].name} (${vm.area_codes[0].dial_code})`;

        $rootScope.title = '다영이 체험수업 신청';
        vm.references = [
            {
                display_name: '네이버 검색 ( Naver search )',
                id: 'naver'
            },
            {
                display_name: '구글 검색 ( Google Search )',
                id: 'google'
            },
            {
                display_name: '지인 소개 ( Referral )',
                id: 'referral'
            },
            {
                display_name: '전단지 ( Flyers )',
                id: 'flyers'
            },
            {
                display_name: '고파스 ( Koreapas )',
                id: 'koreapas'
            },
            {
                display_name: '페이스북 ( Facebook )',
                id: 'facebook'
            },
            {
                display_name: '인스타그램 ( Instagram )',
                id: 'instagram'
            },
            {
                display_name: '네이버 블로그 ( Naver Blog )',
                id: 'naver_blog'
            }
        ];
        vm.levels = [
            { display_name: '왕초보 / Low Beginner' },
            { display_name: '초보 / Beginner' },
            { display_name: '중급 / Intermediate' },
            { display_name: '중상급 / Upper intermediate' },
            { display_name: '상급 / Advanced' }
        ];

        vm.regular_minutes = [
            { display_name: '15 minutes' },
            { display_name: '20 minutes' },
            { display_name: '25 minutes' },
            { display_name: '30 minutes' },
            { display_name: '45 minutes' },
            { display_name: '60 minutes' }
        ];
        vm.regular_minutes2 = vm.regular_minutes.slice();

        vm.topics = [
            {
                display_name: '일상 이야기 ( Daily Life )',
                id: 'daily_life'
            },
            {
                display_name: '정치&경제 ( Politics&Economy )',
                id: 'polititcs'
            },
            {
                display_name: '비즈니스 ( Business )',
                id: 'business'
            },
            {
                display_name: '여행 ( Travel )',
                id: 'travel'
            },
            {
                display_name: '사랑 ( Love )',
                id: 'love'
            },
            {
                display_name: '한국 문화와 역사 ( Korean Culture & History )',
                id: 'khist'
            },
            {
                display_name: '필리핀 문화와 역사 ( Philippines Culture & History )',
                id: 'phist'
            },
            {
                display_name: '생각나는대로 ( Anything )',
                id: 'anything'
            }
        ];

        vm.data = {};
        vm.days = [
            'Sundays',
            'Mondays',
            'Tuesdays',
            'Wednesdays',
            'Thursdays',
            'Fridays'
        ];


        vm.getCouponCode = function() {

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/doll_house/`+$stateParams.coupon_code,
            };

            QueryService.query(request)
                .then(
                    function(response) {

                        const data = response.data.data;
                        
                        if(data.items.length === 0) {
                            logger.error('Coupon Code is Invalid');
                            $location.path('doll-house');
                            // return;
                        }

                        if(data.items.length === 1 && data.items[0].date_used) {
                            logger.error('Coupon Code is already used');
                            $location.path('doll-house');
                            // return;
                        }



                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        };

        if($stateParams.coupon_code){
            vm.page = 0;
            vm.getCouponCode();
        }        

        getLimit();
        function getLimit() {
            vm.loaded_limit = false;
            
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: { date: new Date().format('yyyy-mm-dd')},
                hasFile: false,
                route: URLS.base + `/demo_class_limit`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        vm.demo_count = data.count;
                        vm.demo_limit = data.limit;
                        vm.loaded_limit = true;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.get_limits = ()=>{
            if(vm.loaded_limit)
            return Math.max(vm.demo_limit - vm.demo_count, 0);
            else
            return 0;
        }

        vm.submit = function() {

            vm.data.reference_string = vm.reference_string;
            vm.data.topic = vm.selected_topic;
            vm.data.level = vm.selected_level;

            const phone = '('+(vm.area_code || '(+82)').split('(')[1]+vm.data.phone

            console.log(vm.data);

            if (vm.data.preferred_regular_minutes1)
                vm.data.preferred_regular_minutes1 = parseInt(
                    vm.data.preferred_regular_minutes1.split(
                        ' '
                    )[0]
                );
            if (vm.data.preferred_regular_minutes2)
                vm.data.preferred_regular_minutes2 = parseInt(
                    vm.data.preferred_regular_minutes2.display_name.split(
                        ' '
                    )[0]
                );

            vm.data.coupon_code = $stateParams.coupon_code;

            vm.loading = true;
            var request = {
                method: 'POST',
                body: { ... vm.data, phone },
                params: false,
                hasFile: false,
                route: URLS.base + `/demo_class`,
                cache: false
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        // getSchedule($stateParams.user_id);
                        vm.submitted_view = true;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        };

        vm.demo1 = function() {
            show_hour_picker('demo1', 'multiple', '체험수업 일정을 선택해 주세요');
        };
        vm.demo2 = function() {
            show_hour_picker(
                'demo2',
                'multiple',
                'Select time for demo class option 2'
            );
        };

        vm.regular1 = function() {
            show_regular_class('regular1', '희망 정규수업 일정을 선택해 주세요');
        };

        vm.regular2 = function() {
            show_regular_class(
                'regular2',
                'Select time for regular class option 2'
            );
        };

        function show_hour_picker(path, mode, header) {
            var modal = {
                header: header,
                mode: mode
            };

            ModalService.hour_picker_modal(modal, vm.TPLS).then(
                function(response) {
                    vm[path + '_string'] =
                        '<h4><strong>' +
                        response[0].date.format('YYYY-MM-DD') +
                        '</strong></h4>   ' +
                        response
                            .map(x => {
                                return (
                                    '<strong>' +
                                    x.date.format('HH:mm') +
                                    '</strong>'
                                );
                            })
                            .join('  or  ');

                    vm.data[path] = response;
                },
                function(error) {
                    logger.errorFormatResponse(error);
                }
            );
        }

        function show_regular_class(path, header) {
            var modal = {
                header: header
            };

            ModalService.regular_class_modal(modal, vm.TPLS).then(
                function(response) {
                    vm[path + '_string'] =
                        '<h4><strong>' +
                        vm.to_time(response[0].hour) +
                        '</strong></h4>   ' +
                        response
                            .map(x => {
                                return (
                                    '<strong>' + vm.days[x.day] + '</strong>'
                                );
                            })
                            .join('  |  ');

                    vm.data[path] = response;
                },
                function(error) {
                    logger.errorFormatResponse(error);
                }
            );
        }

        vm.to_time = function(hour) {
            return (
                ('' + parseInt(hour / 4)).padStart(2, 0) +
                ':' +
                ('' + hour % 4 * (60 / 4)).padStart(2, 0)
            );
        };

        vm.goToTeacherView = function(){
            $state.go('demo-teacher', { ... $stateParams});
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/demo-class/demo-class.component.js